import React, { useState, useEffect } from 'react';
import './ThemeSwitcher.css';

const THEMES = [
  { id: 'theme-echodigital', name: 'EchoDigital' },
  { id: 'theme-hacker', name: 'Hacker' },
  { id: 'theme-vaporwave', name: 'Vaporwave' },
  { id: 'theme-darcula', name: 'Darcula' },
  { id: 'theme-monokai', name: 'Monokai' },
  { id: 'theme-solarized-dark', name: 'Solarized' },
  { id: 'theme-dracula', name: 'Dracula' },
  { id: 'theme-nord', name: 'Nord' },
  { id: 'theme-gruvbox', name: 'Gruvbox' },
  { id: 'theme-tactical', name: 'Tactical' },
  { id: 'theme-companion', name: 'Companion' },
  { id: 'theme-therapeutic', name: 'Therapeutic' },
  { id: 'theme-education', name: 'Education' },
  { id: 'theme-resurrection', name: 'Resurrection' },
  { id: 'theme-robotics', name: 'Robotics' },
];

interface ThemeSwitcherProps {
  alwaysOpen?: boolean;
  onThemeChange?: () => void;
}

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ alwaysOpen = false, onThemeChange }) => {
  const [currentTheme, setCurrentTheme] = useState('theme-echodigital');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem('theme');
    const savedTheme = raw ?? 'theme-echodigital';
    setCurrentTheme(savedTheme);
    document.body.className = savedTheme;
  }, []);

  const handleThemeChange = (themeId: string) => {
    setCurrentTheme(themeId);
    document.body.className = themeId;
    localStorage.setItem('theme', themeId);
    onThemeChange?.();
  };

  return (
    <div className="theme-switcher">
      {!alwaysOpen && (
        <button
          className="theme-switcher-toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle theme selector"
        >
          THEME
        </button>
      )}
      {(alwaysOpen || isOpen) && (
        <div className="theme-switcher-dropdown">
          {THEMES.map(theme => (
            <button
              key={theme.id}
              className={`theme-option ${currentTheme === theme.id ? 'active' : ''}`}
              onClick={() => handleThemeChange(theme.id)}
            >
              {currentTheme === theme.id && '> '}
              {theme.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
